import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom';

export const OrdersCount = ({orders}) => {

    const [isReady, setIsReady] = useState(false);
    useEffect(() => {
        setIsReady(true);
    });

    if (!isReady) {
        return null;
    }

    const ordersCount = orders.length;

    return createPortal(
        <div>
            заявок отображено: <b>{ordersCount}</b>
        </div>,
        document.getElementById('orders-count-root'),
    );
}
